<template>
  <div class="container is-fluid " id="appnav">
    

    </div>

</template>

<script>
import Axios from "axios";
// import { API_ROOT } from "../config";
// import Cookies from "js-cookie";

// var instance = Axios.create({
//   baseURL: API_ROOT,
//   timeout: 60000
// });

export default {
  name: "navbar",
  data: function() {
    return {};
  },
  created() {
    console.log("Navigation bar...");
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
</style>
